import { render, staticRenderFns } from "./xcxorder.vue?vue&type=template&id=a22c3146&scoped=true&"
import script from "./xcxorder.vue?vue&type=script&lang=js&"
export * from "./xcxorder.vue?vue&type=script&lang=js&"
import style0 from "./xcxorder.vue?vue&type=style&index=0&id=a22c3146&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22c3146",
  null
  
)

export default component.exports